import { render, staticRenderFns } from "./ResearchList.vue?vue&type=template&id=f3190ace"
import script from "./ResearchList.vue?vue&type=script&lang=js"
export * from "./ResearchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3190ace')) {
      api.createRecord('f3190ace', component.options)
    } else {
      api.reload('f3190ace', component.options)
    }
    module.hot.accept("./ResearchList.vue?vue&type=template&id=f3190ace", function () {
      api.rerender('f3190ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/research/ResearchList.vue"
export default component.exports